import React, { Component } from "react";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { HistoryProcedure, ProcedureIDs } from "@10x/tabu-mobile-api";
import ListDataView from "../DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import {
	getTabuReqDate,
	getTabuReqDateTimeStamp,
	getTabuReqPropertyType,
	getTabuReqStatus,
	getTabuReqTransactionNo,
	getTabuReqVoucherNo
} from "@my-dld/screens/MyDLD/MyRequest/TabuRequests";

export interface TabuReqProps {
	procedureId: string;
	items: HistoryProcedure[];
	onDetails: ( req: HistoryProcedure ) => void;
}

class TabuRequestsListView extends Component<TabuReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { procedureId, items } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader procedureId={ procedureId }/>;
			} }
			renderListItem={ ( item: HistoryProcedure ) => {
				return <RenderListItem
					key={ item.Identity }
					procedureId={ procedureId }
					item={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		const { procedureId } = this.props;
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true,
				order: procedureId === ProcedureIDs.PROPERTY_DETAIL_CERT.toString() ? [ [ "3", "desc" ] ] : undefined,
			} );
			const onDetails = this.props.onDetails;
			window.$( "#ListView" ).on( "click", "tr", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader( props: { procedureId: string } ) {
	const { procedureId } = props;
	return <tr>
		{ procedureId !== "" + ProcedureIDs.TO_WHOM_CONCERN && <th>{ Strings.property_type }</th> }
		<th>{ Strings.transaction_number }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.submission_date }</th>
		{ procedureId !== "" + ProcedureIDs.INTERNAL_PROPERTY_VALUATION &&
			<th>{ Strings.voucher_number }</th> }
		<th>{ " " }</th>
	</tr>;
}

function RenderListItem( props: { procedureId: string, item: HistoryProcedure } ) {
	const { procedureId, item } = props;
	return <tr data-item={ JSON.stringify( item ) } className="clickable-row">
		{ procedureId !== "" + ProcedureIDs.TO_WHOM_CONCERN &&
			<td data-label={ Strings.property_type }>{ getTabuReqPropertyType( item ) }</td> }
		<td data-label={ Strings.transaction_number }>{ getTabuReqTransactionNo( item ) }</td>
		<td data-label={ Strings.status }>{ getTabuReqStatus( item ) }</td>
		<td data-sort={ getTabuReqDateTimeStamp( item ) } data-label={ Strings.submission_date }>{ getTabuReqDate( item ) }</td>
		{ procedureId !== "" + ProcedureIDs.INTERNAL_PROPERTY_VALUATION &&
			<td data-label={ Strings.voucher_number }>{ getTabuReqVoucherNo( item ) }</td> }
		<td className="text-center">
			<span className="table-view-detail-link"> { Strings.view_details } </span>
			<i className="far fa-arrow-alt-circle-right"/>
		</td>
	</tr>;
}

export default TabuRequestsListView;
